// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { RoleDetailsFacadeService } from './../../../../state/role-details.facade';
import { UserDetailsFacadeService } from '@app/access-management/state/user-details/user-details.facade';
import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AlertService } from '@app/core/services/alert.service';
import { readParameterFromRouterState, RolesService, RoleUserSelections } from '@app/core';
import { ActivatedRoute } from '@angular/router';
import {
  LoadingRoleDetailsAction,
  selectRoleUserSelections,
  SelectUsersForRoleAction
} from '@app/access-management/state';
import { switchMap, take, tap } from 'rxjs/operators';

@Component({
  selector: 'app-user-details-role-scopes',
  templateUrl: './user-details-role-scopes.component.html'
})
export class UserDetailsRoleScopesComponent implements OnInit {
  user$: any;
  role$: any;
  addUserScopeMode = false;
  roleId: any;
  username: any;
  _isValid = false;
  _selectedUser: any;
  useProjectCommitteeHandler = false;
  randomIdx = Math.random();

  constructor(
    private store: Store<any>,
    private alertService: AlertService,
    private rolesService: RolesService,
    private activatedRoute: ActivatedRoute,
    private userDetailsFacadeService: UserDetailsFacadeService,
    private roleDetailsFacadeService: RoleDetailsFacadeService
  ) {
    this.roleId = readParameterFromRouterState(this.activatedRoute, 'id');
    this.username = readParameterFromRouterState(this.activatedRoute, 'username');
    this.userDetailsFacadeService.initialize(this.username);
    this.roleDetailsFacadeService.initialize(this.roleId);

    this.user$ = this.userDetailsFacadeService.user$.pipe(tap(data => (this._selectedUser = data)));
    this.role$ = this.roleDetailsFacadeService.roleDetailsData$;
  }

  ngOnInit(): void {}

  onOptionSelected(option: string) {
    this.useProjectCommitteeHandler = option === 'project|committee';
  }

  addUserScope() {
    this.addUserScopeMode = true;
  }

  updateValidity(isValid: boolean) {
    this._isValid = isValid;
  }

  isValid() {
    return this._isValid;
  }

  cancel() {
    this.addUserScopeMode = false;
  }

  onSaved() {
    this.addUserScopeMode = false;
    // refresh scope tables
    this.randomIdx = Math.random();
  }

  submit() {
    if (!this.isValid) {
      return;
    }

    const submit$ = this.store.pipe(
      select(selectRoleUserSelections(this.roleId)),
      switchMap((roleUserSelections: RoleUserSelections) => {
        const request = roleUserSelections;
        if (!request.users || !request.users.length) {
          request.users = [this._selectedUser];
        }

        return this.rolesService.updateUserScope(this.roleId, roleUserSelections);
      })
    );
    submit$.pipe(take(1)).subscribe(
      _ => {
        this.reloadRoleDetail();
        this.alertService.success(`Successfully updated user.`);
      },
      err => {
        this.alertService.error('Failed to assign user to role.');
      }
    );
  }

  reloadRoleDetail() {
    this.store.dispatch(new LoadingRoleDetailsAction(this.roleId));
    this.store.dispatch(new SelectUsersForRoleAction({ roleId: this.roleId, selectedUsers: [this._selectedUser] }));
    this.addUserScopeMode = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/access-management/users/user-details/user-details-roles-tab/user-details-role-scopes/user-details-role-scopes.component.ts